module.exports = __webpack_public_path__ + "img/fork-spinner.d2484367.svg";